module.exports = __webpack_public_path__ + "settings-1271fc970e3a71a6d82e5d84acc9e335.svg";